import React, { Fragment } from 'react'
import CustomTitle from '../CustomTitle/CustomTitle.jsx'

export default function AnalysisProfile() {
   return (
      <Fragment>
         <CustomTitle title="بروفايلات الخدمات " />

         <div className="container">
            <h2 className='main-header '>Analysis Profile</h2>
            <div className='under-header'></div>

            <div className="row" >
               <p>Not Found Data Today`s</p>
            </div>
         </div>
      </Fragment>
   )
}
